import { Box } from "@mui/material";
import { FC } from "react";
import { Footer } from "./footer/footer";
import { Header } from "./header/header";
import { classes } from "./layout.styles";

type Props = {
  children?: React.ReactNode;
  withSpacing?: boolean;
};

export const Layout: FC<Props> = ({ children, withSpacing = false }) => {
  return (
    <Box sx={classes.root}>
      <Header />
      <Box component="main" sx={classes.content}>
        <Box sx={{ ...classes.children, ...(withSpacing && classes.spacing) }}>
          {children}
        </Box>
      </Box>
      <Footer />
    </Box>
  );
};

export default Layout;
